import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const FilterNewIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 h-6"
      width={width}
      height={height}
      viewBox="-4 -4 40 40"
    >
      <polygon
        points="30 5 19 16 19 26 13 30 13 16 2 5 2 1 30 1 30 5"
        fill="none"
        stroke={color}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeWidth={2.4}
      />
    </svg>
  );
};
